import { object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'
import { hasVisibleCharacters } from '@calendly/rich-text-editor'

export const supportedFormattingForBody = [
  'bold',
  'italic',
  'underline',
  'list'
]

export const logoName = {
  gmail: 'gmail',
  outlook: 'microsoft-outlook'
}

export const validationSchema = () => object().shape({
  body: object().test('validateBody', '', (body, { createError }) => {
    if (!body.delta && body.html && body.html.length) {
      return true
    }

    if (body.delta && hasVisibleCharacters(body)) {
      return true
    }

    return createError({
      message: I18n.t('errors.messages.blank')
    })
  }),
  subject: object().test('validateSubject', '', (subject, { createError }) => {
    if (!subject.delta && subject.plainText && subject.plainText.length) {
      return true
    }

    if (subject.delta && hasVisibleCharacters(subject)) {
      return true
    }

    return createError({
      message: I18n.t('errors.messages.blank')
    })
  }),
  send_with: string().required(I18n.t('publisher.booking_modal.required_label'))
})
